import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { Calendar, Clock, MapPin, User, ExternalLink } from "lucide-react";

export function EventDetailModal({ event, open, onOpenChange }) {
  if (!event) return null;

  const button = registerButtonState(event);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="event-detail-modal">
        <DialogHeader>
          <div className="flex items-start gap-2 flex-wrap">
            <StatusBadge status={event.category} />
            <StatusBadge status={event.event_status} />
          </div>
          <DialogTitle className="text-2xl mt-2 font-heading">{event.title}</DialogTitle>
          {event.short_title && <DialogDescription>{event.short_title}</DialogDescription>}
        </DialogHeader>

        <div className="space-y-3 text-sm">
          <div className="flex items-center gap-2"><Calendar className="h-4 w-4 text-primary" /><span>{formatDateBM(event.event_date)}</span></div>
          <div className="flex items-center gap-2"><Clock className="h-4 w-4 text-primary" /><span>{event.start_time} – {event.end_time}</span></div>
          <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-primary" /><span className="capitalize">{event.location_type}: {event.location || "—"}</span></div>
          {event.speaker_name && (
            <div className="flex items-center gap-2"><User className="h-4 w-4 text-primary" /><span>{event.speaker_name}</span></div>
          )}
          {event.description && (
            <div className="pt-3 border-t border-border text-muted-foreground leading-relaxed">{event.description}</div>
          )}
        </div>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="event-modal-close">Close</Button>
          <Button
            disabled={button.disabled}
            onClick={() => {
              if (event.registration_link) window.open(event.registration_link, "_blank");
            }}
            data-testid="event-register-btn"
            className="btn-glow"
          >
            {!button.disabled && <ExternalLink className="h-4 w-4" />}
            {button.label}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function registerButtonState(event) {
  if (event.event_status === "full") return { label: "Penuh", disabled: true };
  if (event.event_status === "closed") return { label: "Registration Closed", disabled: true };
  if (event.event_status === "completed") return { label: "Event Expired", disabled: true };
  if (event.event_status === "cancelled") return { label: "Event Cancelled", disabled: true };
  if (event.event_status === "open_registration" && event.registration_link) {
    return { label: event.category === "berbayar" ? "Register (Paid)" : "Register (Free)", disabled: false };
  }
  return { label: "Link Coming Soon", disabled: true };
}

function formatDateBM(yyyymmdd) {
  if (!yyyymmdd) return "";
  const [y, m, d] = yyyymmdd.split("-");
  const months = ["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"];
  return `${parseInt(d, 10)} ${months[parseInt(m, 10) - 1]} ${y}`;
}
